import { render, staticRenderFns } from "./SendEmailCode.vue?vue&type=template&id=db7b7e36&scoped=true&"
import script from "./SendEmailCode.vue?vue&type=script&lang=js&"
export * from "./SendEmailCode.vue?vue&type=script&lang=js&"
import style0 from "./_sendEmailCode.scss?vue&type=style&index=0&id=db7b7e36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7b7e36",
  null
  
)

export default component.exports